(function () {
  var INTERVAL = 5000; // change image every 5s while hovering

  function initSlideshow(el) {
    if (el.dataset.slideshowWired) return;
    el.dataset.slideshowWired = 'true';

    var slides = el.querySelectorAll('.card__slide');
    if (slides.length < 2) return;

    // Hover must be tracked on the whole card, not the image: Dawn overlays an
    // invisible full-card link on top of the media, which would otherwise
    // swallow mouseenter on the image element itself.
    var hoverTarget = el.closest('.card-wrapper') || el.closest('.card') || el;

    var current = 0;
    var timer = null;

    function show(index) {
      slides[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
    }

    hoverTarget.addEventListener('mouseenter', function () {
      if (timer) return;
      timer = setInterval(function () {
        show((current + 1) % slides.length);
      }, INTERVAL);
    });

    hoverTarget.addEventListener('mouseleave', function () {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      show(0); // revert to the featured image
    });
  }

  function init() {
    document.querySelectorAll('.card__media-slideshow').forEach(initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
